// AUTO-GENERATED by scripts/sync-pdf-worker.js — DO NOT EDIT.
// Regenerated on `yarn start` and `yarn build` (see package.json).
export const PDF_WORKER_BUILD_VERSION = "5.4.296";
export const PDF_WORKER_BUILD_SIZE = 1046214;
export const PDF_WORKER_BUILD_SHA256 = "dbcae78a691b3c50";
export const PDF_WORKER_BUILD_AT = "2026-11-05T00:06:59.976Z";
